import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of, Subject } from 'rxjs';
import { map } from 'rxjs/operators';
import { FormControl } from '@angular/forms';
@Injectable({
    providedIn: 'root',
})

export class OfficerSearchService {

constructor(private httpClient: HttpClient) { }

    //Service changes added
    searchVehicle(data): Observable<any> {
        return this.httpClient.post('api/enforcement/searchVehicle',
        {data})
        .pipe(
            map((body: any) => {
                if (body == 500) {
                    throw new Error('error');
                  } else {
                    return body;
                  }
            })
        )
    }

    createEnforcementDetails(data): Observable<any> {
        return this.httpClient.post('api/enforcement/createEnforcementDetails',
            { data })
            .pipe(
                map((body: any) => {
                    if (body == 500) {
                        throw new Error('error');
                      } else {
                        return body;
                      }
                })
            );
    }

    submitParkingDetails(data){
    return this.httpClient.post('api/parking/createParkingDetails',
            { data })
            .pipe(
                map((body: any) => {
                    if (body == 500) {
                        throw new Error('error');
                      } else {
                        return body;
                      }
                })
            );}


            customFieldValidator(control: FormControl) {
                let pattern = /((^[0-9]+[a-z]+)|(^[a-z]+[0-9]+))+[0-9a-z]+$/i;
                let value = `${control.value}`;
            
                if (value.match(pattern)) {
                  return null;
                } else {
                  return {
                    patternValidation: true
                  }
                }
              }  
              
              
    getEnforcemnetWaiver(data): Observable<any> {
      let params: any = {};
      params.plateNo = data.plateNo;
      params.stateId = data.stateId;
      // params.userSelectedYear = userSelectedYear;
      return this.httpClient.get('api/enforcement/getEnforcemnetWaiver',
          { params: params })
          .pipe(
              map((body: any) => {
                  if (body == 500) {
                      throw new Error('error');
                  } else {
                      return body;
                  }
              })
          );
  }
}